import React from 'react';
import c from 'classnames';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIconSmall from '@wix/da-ds/pkg/Icons/16x16/Tier';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import useIconSizeForButtonSize from '@wix/da-ds/pkg/Buttons/hooks/useIconSizeForButtonSize';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useSubscribeButton } from '../useSubscribeButton';
import s from './Subscribe.scss';
const SubscribeVariant = ({ tier, withPrice = false, size = 'medium', className, href })=>{
    const { onClick, biData, text } = useSubscribeButton(tier, {
        type: 'subscribe',
        withPrice
    });
    const iconSize = useIconSizeForButtonSize(size);
    const icon = iconSize === IconSize.SMALLER ? TierIconSmall : TierIcon;
    return /*#__PURE__*/ React.createElement(SolidButton, {
        isFakeButton: true,
        className: c(s['root'], className),
        icon: icon,
        size: size,
        variant: "main",
        href: href,
        onClick: onClick,
        biData: biData
    }, text);
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;

//# sourceMappingURL=Subscribe.js.map